import styled from "@emotion/styled";


export const GifContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(200px, 1fr));
    grid-gap: 15px 15px;
    align-items: center;
    min-height: 100vh;
`